import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const UPDATE_CONTENT_AUDIO_SNIPPET = gql`
  mutation updateQuestionContentSnippet($snippetId: Int!, $startAt: Float!, $assetId: String!, $duration: Float!, $title: String!) {
    contentSnippet {
      updateContentSnippet(
        baseSnippet: { id: $snippetId, entityTitle: $title }
        contentSnippetAudio: { startAt: $startAt, assetId: $assetId, duration: $duration }
      ) {
        id
        sort
        visible
      }
    }
  }
`;

const updateContentAudioSnippetReq = ({ snippetId, startAt, assetId, duration, onSuccessResult, onError }) => (
  <Mutation mutation={UPDATE_CONTENT_AUDIO_SNIPPET}>
    {(updateContentSnippet, { loading, error, data }) => {
      const variables = {
        snippetId,
        startAt,
        assetId,
        duration,
        title: '',
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.contentSnippet.updateContentSnippet.id, data.contentSnippet.updateContentSnippet.sort);
      }

      return <MutationRequest isLoading={loading} mutation={updateContentSnippet} variables={variables} />;
    }}
  </Mutation>
);

updateContentAudioSnippetReq.propTypes = {
  assetId: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  snippetId: PropTypes.number.isRequired,
  startAt: PropTypes.number.isRequired,
};

export default updateContentAudioSnippetReq;
